import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Chip, IconButton, Stack, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DateRangeSelector from '../../../../components/DateTime/DateRangeSelector'
import { statusColor } from './tileColors'

const scoreStatus = (healthScore) => {
  if (healthScore === null || healthScore === undefined) return 'neutral'
  if (healthScore >= 80) return 'success'
  if (healthScore >= 60) return 'warning'
  return 'error'
}

const KPIPageLayout = ({ title, subtitle, backTo, dateRange, healthScore, actions, children }) => {
  const navigate = useNavigate()
  const colors = statusColor(scoreStatus(healthScore))
  const showChip = healthScore !== undefined && healthScore !== null

  return (
    <Stack gap={1.5} padding={1}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
        gap={1.5}
      >
        <Stack direction="row" alignItems="center" gap={1} flex={1} minWidth={0}>
          {backTo ? (
            <IconButton onClick={() => navigate(backTo)} size="small" sx={{ flexShrink: 0 }}>
              <ArrowBackIcon />
            </IconButton>
          ) : null}
          <Box minWidth={0}>
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
              <Typography variant="title2" noWrap>
                {title}
              </Typography>
              {showChip ? (
                <Chip
                  size="small"
                  label={`${healthScore}% on target`}
                  sx={{
                    backgroundColor: `${colors.main}18`,
                    color: colors.main,
                    fontWeight: 700,
                  }}
                />
              ) : null}
            </Stack>
            {subtitle ? (
              <Typography variant="caption" color="text.secondary" display="block" noWrap>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{ flexShrink: 0, width: { xs: '100%', md: 'auto' } }}
        >
          {actions}
          <Box sx={{ width: { xs: '100%', md: 280 } }}>
            <DateRangeSelector value={dateRange.value} onChange={dateRange.onChange} />
          </Box>
        </Stack>
      </Stack>
      {children}
    </Stack>
  )
}

export default KPIPageLayout
